export default {
  orderBaseCurrenciesTitle: "Base Currency:",
  avatar: {
    status: "Status",
    unverified: "Not Verified"
  },
  menu: {
    dashborad: "Dashboard",
    wallet: {
      wallet: "Wallet",
      main: "Main",
      mainDetail: "Deposit , Withdrawal",
      spot: "Spot (Market)",
      spotDetail: "Spot wallet",
      transfer: {
        transfer: "Transfer",
        transferDetail: "Transfer between main and spot",
        transferToMain: "Spot to Main",
        transfertToMainDetail: "Transfer assets",
        transferToSpot: "Main to Spot",
        transfertToSpotDetail: "Transfer assets"
      }
    },

    dealing: {
      dealing: "Trade",
      fastConvert: "Fast Convert",
      fastConvertDetail: "convert one currency to another",
      spot: "Spot ( Market)",
      spotDetail: "P2P Trade",
      ordering: "OTC Trade",
      orderingDetail: "Place Order in OTC",
      testMarket: "Spot (Demo)",
      testMarketDetail: "Demo P2P Trade",
      perfectMoney: "Perfect Money",
      perfectMoneyDetail: "Buy/Sell Perfect Money",
      withdrawHistory: "Withdraw History",
      depositHistory: "Deposit History"
    },
    api_management: "API Management",
    markets: "Markets",
    prices: "Currencies",
    orders: {
      orders: "Orders",
      openOrders: "Open orders (Spot)",
      openOrdersDetail: "Your Open orders",
      profitLossLimit: "Stop/Limit (Spot)",
      profitLossLimitDetail: "Your Open Stop/Limit Orders",
      history: {
        history: "History",
        historyDetail: "History Of All Orders",
        openOrders: "Orders (Spot)",
        openOrdersDetail: "History of open orders",
        profitLossLimit: "Stop/Limit (Spot)",
        profitLossLimitDetail: "History Stop/Limit",
        otc: "Fast & OTC Trade",
        otcDetail: "History of OTC",
        transactions: "Transactions (Spot)",
        transactionsDetail: "History of Transactions"
      }
    },
    investing: {
      investing: "Investment",
      staking: "Staking",
      stakingDetail: "Staking , Liquidity pools",
      partnershipFunds: "Mutual funds",
      partnershipFundsDetail: "mutual funds Plan",
      uranus: "Uranus Plan",
      uranusDetail: "Uranus funds plans"
    },
    gateway: "Crypto Gateway",
    blog: "Blog"
  },
  navigationDrawer: [
    {
      to: "/dashboard",
      tooltip: "Dashboard",
      icon: "$vuetify.CustomIcon.dashboardIcon"
    },
    {
      to: "/wallet/main",
      tooltip: "Wallet",
      icon: "$vuetify.CustomIcon.walletIcon"
    },
    {
      to: "/operations/exchange?from=",
      tooltip: "Quick Exchange",
      icon: "$vuetify.CustomIcon.exchangeIcon"
    },
    // {
    //   to: process.env.VUE_APP_MARKET_BASE_URL,
    //   tooltip: "Excoino Market",
    //   icon: "$vuetify.CustomIcon.marketLogo",
    //   customLink: true
    // },
    {
      to: `/exchange/v-btc_v-usdt`,
      tooltip: "Demo Market",
      icon: "$vuetify.CustomIcon.demoTrading",
    },
    {
      to: "/order",
      tooltip: "Order Placement",
      icon: "$vuetify.CustomIcon.newTradeIcon"
    },
    {
      to: "https://hello.excoino.com/fund/",
      tooltip: "Investment",
      icon: "$vuetify.CustomIcon.investment",
      customLink: true
    },
    {
      to: "/prices",
      tooltip: "Currency Prices",
      icon: "$vuetify.CustomIcon.priceList"
    },
    {
      to: "/history/transaction",
      tooltip: "Transaction History",
      icon: "$vuetify.CustomIcon.orderHistoryIcon"
    },
    {
      to: "/gifts",
      tooltip: "Gifts",
      icon: "$vuetify.CustomIcon.giftIcon"
    },
    {
      to: "/referral",
      tooltip: "Invite Friends",
      icon: "$vuetify.CustomIcon.referral"
    },
    {
      to: "/tickets",
      tooltip: "Support Tickets",
      icon: "$vuetify.CustomIcon.supportIcon"
    }
  ],
  market: {
    tooltip: "Excoino Market"
  },
  exit: {
    tooltip: "Logout"
  },
  changeTheme: {
    tooltip: "Change Theme Color"
  }
};
